import { Decimal } from "decimal.js"
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { httpConfig } from '@/api/api'
import axios from 'axios'
export const global = {
  user_level: 0,
  setUserLevel: function (level) {
    this.user_level = level
  }
}
const DOMAIN = httpConfig.COLA.slice(httpConfig.COLA.indexOf('.'))

//设置cookie   name为cookie的名字，value是值，expiredays为过期时间（天数）
export function  setCookie(NameOfCookie, value, expires) {
  //@参数:三个变量用来设置新的cookie:
  //cookie的名称,存储的Cookie值,
  // 以及Cookie过期的时间.
  var ExpireDate = new Date()
  ExpireDate.setTime(ExpireDate.getTime() + (expires * 1000))
  // 获取根域名
  // 下面这行是用来存储cookie的,只需简单的为"document.cookie"赋值即可.
  // 注意日期通过toGMTstring()函数被转换成了GMT时间。
  document.cookie = NameOfCookie + "=" + escape(value) + "; path=/; domain=" + DOMAIN + ((expires == null) ? "" : "; expires=" + ExpireDate.toGMTString())
}

export function toLogin(url, type) {
  const { COLAHOST } = httpConfig
  let action = 'sgporsu'
  if (type === 'tl') {
    action = 'TL'
  }
  if (process.env.ENV_CONFIG === 'dev') {
    setCookie('dev', '1')
  }
  return `${COLAHOST}Login.aspx/?toUrl=${encodeURIComponent(`${COLAHOST}Quality/SkipQuality_Test.aspx?Action=${action}&&redirect_url=${encodeURIComponent(encodeURIComponent(url))}`)}`
}

export function toMainPage(type) {
  window.location.href= this.$httpConfig.COLAHOST + 'Vendor/'
}

//删除cookie
export function delCookie(NameOfCookie, domain) {
  // 该函数检查下cookie是否设置，如果设置了则将过期时间调到过去的时间;
  //剩下就交给操作系统适当时间清理cookie啦
  if (domain) {
    document.cookie = NameOfCookie + "=null; Domain=" + domain + "; expires=Thu, 01-Jan-70 00:00:01 GMT; Path=/"
  } else {
    document.cookie = NameOfCookie + "=" + "; expires=Thu, 01-Jan-70 00:00:01 GMT"
  }
}
//删除cookie
export function getCookie(NameOfCookie) {
  //arr 是正则匹配的结果 matchCookie是函数要返回的值
  var arr, matchCookie
  //正则匹配cookie
  //(^| )匹配cookie开头或者空格
  //([^;]*)匹配除分号以外的任意字符
  //(;|$)匹配分号或整个cookie的结尾
  var reg = new RegExp("(^| )" + NameOfCookie + "=([^;]*)(;|$)");
  //三元操作符  判断在document.cookie里面是否有想要获得的cookie
  //如果有就返回 如果没有就返回null
  (arr = document.cookie.match(reg)) ? matchCookie = unescape(arr[2]) : matchCookie = null
  return matchCookie
}
// 判断susgp是否登录
export function isSuSgpLogin() {
  if (!getCookie("sunflower_test_sid")) {
    // 如果有一个不存在
    delCookie('sunflower_test_sid')
  }
  return getCookie("sunflower_test_sid") ? true : false;
}
// 判断tl是否登录
export function isTlLogin() {
  if (!getCookie("sunflower_test_sid")) {
    // 如果有一个不存在
    delCookie('sunflower_test_sid')
  }
  return getCookie("sunflower_test_sid") ? true : false;
}
// 判断是否登录
export function passwordValid(rule, value, callback) {
  let reg = new RegExp(/^(?!\D+$)(?![^a-zA-Z]+$)([\x20-\x7f]){8,32}$/);
  if (!reg.test(value)) {
    callback(new Error('必须为8-32位数字和字母或字符组合'))
  } else {
    callback()
  }
}
export function baiduCount() {
  if (location.hostname.indexOf('zhengyitech.com') > -1) {
    var _hmt = _hmt || []
    (function () {
      var hm = document.createElement("script")
      hm.src = "https://hm.baidu.com/hm.js?23f43c4c5aa6eba959c001fec0761b91"
      var s = document.getElementsByTagName("script")[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }
}
// 获取用户信息
export function getUserInfo(){
  var user_info = getCookie("cola_test_user_info");
  if (user_info) {
    user_info = user_info.replace(/\\054/g, ',')
    user_info = JSON.parse(user_info)
    return JSON.parse(user_info)
  } else {
    return null
  }
}

export function dateToString(date) {
  if (date instanceof Date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    month = month < 10 ? '0' + month : month
    var day = date.getDate()
    day = day < 10 ? '0' + day : day
    return year + "" + month + "" + day
  }
  return ''
}
// 验证手机号码格式
export function phoneValid(rule, value, callback){
  var re = new RegExp(/^[1][3456789]\d{9}$/)
  if(re.test(value)){
    callback()
  }else{
    callback(new Error('请输入正确格式的手机号码'))
  }
}
// 验证汉字
export function isHan(rule, value, callback){
  var re = new RegExp(/^[\u4e00-\u9fa5]+$/)
  if(re.test(value)){
    callback(new Error('请输入非汉字'))
  }else{
    callback()
  }
}
// 验证密码
export function passWord(rule, value, callback) {
  var re = new RegExp(/^(?!\D+$)(?![^a-zA-Z]+$)([\x20-\x7f]){8,32}$/)
  if (re.test(value)) {
    callback()
  } else {
    callback(new Error('必须为8-32位数字和字母或字符组合'))
  }
}
// 验证身份证
export function isIdCard(rule, value, callback) {
  //身份证正则表达式(18位)
  var isIdCard2 = /^[1-9]\d{5}(19\d{2}|[2-9]\d{3})((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])(\d{4}|\d{3}X)$/i
  var stard = "10X98765432" //最后一位身份证的号码
  var first = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] //1-17系数
  var sum = 0
  if (!isIdCard2.test(value)) {
    callback(new Error('请输入正确的身份证号'))
  }
  var year = value.substr(6, 4)
  var month = value.substr(10, 2)
  var day = value.substr(12, 2)
  var birthday = value.substr(6, 8)
  if (birthday != dateToString(new Date(year + '/' + month + '/' + day))) {//校验日期是否合法
    callback(new Error('请输入正确的身份证号'))
  }
  for (var i = 0; i < value.length - 1; i++) {
    sum += value[i] * first[i]
  }
  var result = sum % 11
  var last = stard[result] //计算出来的最后一位身份证号码
  if (value[value.length - 1].toUpperCase() == last) {
    callback()
  } else {
    callback(new Error('请输入正确的身份证号'))
  }
}
// 验证营业执照号
export function isbusinessLicenseId(rule, value, callback) {
  if(value.length == 15 || value.length == 18){
    callback()
  }else{
    callback(new Error('请输入正确格式的营业执照号'))
  }
}
// 验证图片验证码
export function imgCodeValid(rule, value, callback) {
  var re = new RegExp(/^\d{4}$/)
  if(re.test(value)){
    callback()
  }else{
    callback(new Error('请输入正确的图片验证码'))
  }
}
// 验证短信验证码
export function messageCodeValid(rule, value, callback){
  var re = new RegExp(/^\d{6}$/)
  if(re.test(value)){
    callback()
  }else{
    callback(new Error('请输入正确的短信验证码'))
  }
}
// 验证银行卡号
export function bankCardValid(rule, value, callback) {
  var re = new RegExp(/^([1-9]{1})(\d{15}|\d{17}|\d{18})$/)
  if (re.test(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的银行卡号'))
  }
}
// 复制
export function contentCopy(text) {
  let time = new Date().getTime()
  let div_temp = document.createElement('div')
  div_temp.innerHTML = '<input type="text" value="' + text + '" class="copy' + time + '"></input>'
  document.body.appendChild(div_temp)
  let ele = document.body.getElementsByClassName('copy' + time)[0]
  ele.select()
  ele.setSelectionRange(0, text.length)
  document.execCommand("Copy") //执行浏览器复制命令
  this.$message.success('复制成功')
  document.body.removeChild(div_temp)
}
//金额转换
export function fen_to_yuan(value, fixed_num, number) {
  if(!value){
    return 0
  }
  if (fixed_num == null) {
    fixed_num = 0
  }
  if (number) {
    return Number(Decimal.div(value, 100).toFixed(fixed_num))
  }
  return Decimal.div(value, 100).toFixed(fixed_num)
}
//金额转换
export function yuan_to_fen(val) {
  return Decimal.mul(Number(val).toFixed(2), 100).toNumber()
}
export function amountLimit(rule, value, callback) {
  var re = new RegExp(/^([0]|[1-9][0-9]*)(\.[0-9]{1,2})?$/)
  if (re.test(value) && value > 0) {
    callback()
  } else {
    callback(new Error('请输入正确的金额'))
  }
}
// 文件格式校验
export function validFile(value, format) {
  let fileName = value.split('\\').pop()
  if (fileName == '') { return true }
  let fileTArr = fileName.toLowerCase().split(".")
  let filetype = fileTArr[fileTArr.length - 1]
  if (format && format.indexOf(filetype) <= -1) {
    return false
  } else {
    return true
  }
}
// 获取
export function getParameterByName(name, url) {
  if (!url) url = decodeURIComponent(window.location.href)
  name = name.replace(/[\[\]]/g, "\\$&")
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2])
}

// 根据url获取文件名
export function getFileName(o){
  if (!o) return ''
  var pos=o.lastIndexOf('/')
  return o.substr(pos+1)
}

// 根据url获取文件名
export function getFileSuffix(o){
  let fileTArr = o.toLowerCase().split(".")
  return fileTArr[fileTArr.length - 1]
}

// 通用上传文件
export async function uploadFile(content, size = 1, type) {
  // type：自定义校验类型，举例：['jpg','png','pdf']
  if (type) {
    const fileType = validFile(content.file.name, type)
    if (!fileType) {
      return {
        code: -1,
        message: '请上传正确格式文件'
      }
    }
  }
  const isLt2M = content.file.size / 1024 / 1024 < size
  console.log(content.file.size / 1024 / 1024)
  if (!isLt2M) {
    return {
      code: -1,
      message: `上传文件大小不能超过 ${size}MB!`
    }
  }
  const img_type =  ['png', 'jpg', 'jpeg']
  const text_type =  ['txt','doc','docx','xls','xlsx','ppt','pptx','pdf']
  const zip_type =  ['rar','zip']
  let upload_type = 1
  if(validFile(content.file.name, text_type)){
    upload_type = 2
  }else if(validFile(content.file.name, img_type)){
    upload_type = 1
  }else if(validFile(content.file.name, zip_type)){
    upload_type = 3
  }
  let form = new FormData()
  form.append("file", content.file)
  form.append("upload_type", upload_type)
  try {
    const res = await axios.post(content.action, form)
    if(res.data.code != 0) {
      return {
        code: -1,
        message: '文件上传失败, code:' + res.data.code
      }
    } else {
      return {
        code: 0,
        url: res.data.file_path,
        message: '文件上传成功'
      }
      // this.$message.success('文件上传成功')
      // content.onSuccess('文件上传成功！')
    }
  } catch (error) {
    return {
      code: -1,
      message: `上传文件失败`
    }
  }
}



// 转PDF
export function getPdf (idname, pdftitle) {
  var title = pdftitle
  html2Canvas(document.querySelector(idname), {
    allowTaint: true
  }).then(function (canvas) {
    let contentWidth = canvas.width
    let contentHeight = canvas.height
    let pageHeight = contentWidth / 592.28 * 841.89
    let leftHeight = contentHeight
    let position = 0
    let imgWidth = 595.28
    let imgHeight = 592.28 / contentWidth * contentHeight
    let pageData = canvas.toDataURL('image/jpeg', 1.0)
    let PDF = new JsPDF('', 'pt', 'a4')
    if (leftHeight < pageHeight) {
      PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      while (leftHeight > 0) {
        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= 841.89
        if (leftHeight > 0) {
          PDF.addPage()
        }
      }
    }
    PDF.save(title + '.pdf')
  }
  )
}



// WEBPACK FOOTER //
// ./src/assets/js/until.js